import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Scroll-driven horizontal strip of testimonials — reads from the backend
// (editable in /admin), falling back to the bundled starter content.
export default function TestimonialsStrip() {
  const [testimonials, setTestimonials] = useState(TESTIMONIALS);

  useEffect(() => {
    fetch(`${API}/site-content`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d?.testimonials?.length) setTestimonials(d.testimonials);
      })
      .catch(() => {});
  }, []);

  // Duplicate for a seamless marquee loop — repeat until at least 6 cards.
  let base = [...testimonials];
  while (base.length > 0 && base.length < 6) base = [...base, ...testimonials];
  const items = [...base, ...base];
  return (
    <section
      data-testid="testimonials-section"
      className="bg-[#1A1A1A] text-white border-y-2 border-[#1A1A1A] overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-12 pt-14 md:pt-20 pb-8">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div className="max-w-2xl">
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#FFD700]">
              What partners say
            </p>
            <h2 className="mt-3 font-display font-black text-3xl md:text-5xl leading-[1.02] tracking-tighter">
              The receipts.
            </h2>
          </div>
          <p className="text-sm text-white/60 font-mono uppercase tracking-widest">
            Scroll to read →
          </p>
        </div>
      </div>

      <div className="relative py-6 md:py-10">
        <div className="group flex gap-6 w-max animate-marquee hover:[animation-play-state:paused]">
          {items.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i % (base.length || 1)}`}
              className="relative w-[320px] md:w-[400px] shrink-0 rounded-3xl bg-white text-[#1A1A1A] border-2 border-[#1A1A1A] p-6 md:p-7 nb-shadow"
            >
              <span
                className="absolute -top-4 -left-4 h-10 w-10 rounded-xl border-2 border-[#1A1A1A] flex items-center justify-center nb-shadow-sm"
                style={{ backgroundColor: t.color }}
              >
                <Quote size={18} strokeWidth={2.5} />
              </span>
              <p className="font-display font-black text-lg md:text-xl leading-tight tracking-tight">
                “{t.quote}”
              </p>
              <div className="mt-5 pt-4 border-t-2 border-[#1A1A1A]/10">
                <p className="font-bold text-sm">{t.source}</p>
                <p className="font-mono text-[10px] uppercase tracking-widest text-[#4A4A4A]">
                  {t.org}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
